import LocalizedStrings from 'react-localization';
let strings = new LocalizedStrings({
  en: {
    Aboutbalance:"About balance",
    // common
    eventCreator:"Event Creator",
    Filmshow:"Show For Film",
    showcreatedat:"Creation Date",
    showDescrip:"Show Description",
    noshows:"There is no Shows",
    currentLocation:"Location",
    FilmImage:"Film Image",
    searchRegion:"Search for Regions ...",
    loading:"Loading ...",
    show: "Show",
    preview: "Preview",
    table: "Table",
    card: "Card",
    comingSoon: "Coming Soon",
    call: "Call",
    mailing: "Mail",
    LastActivities: "Latest Shows",
    username: "Name",
    Retry: 'Retry',
    NoExist: 'No Exsit',
    loadMore: "Load More",
    readMore: "read More",
    confirm: "Confirm",
    CancelBTN: "Cancel",
    createBTN: "Create",
    Btn_Filter: "Filter",
    SendKey: "Send",
    addBTN: 'Add',
    edittip: "Edit",
    deletetip: "Delete",
    details: "Details",
    viewtip: "Details",
    EditBTN: "Edit",
    // logout
    SingOut: "Sign Out",
    confirmation: "Are you sure you want to logout",
    logout: "Log Out",
    // Login
    loginKey: "Login",
    UserType: "User Type",
    AdminType: "Admin",
    SubAdminType: "Sub Admin",
    forgetPasswordKey: "Forget Password",
    EnterPassword: "Enter Your Password",
    EnterMail: "Enter Your Email",
    confirmpassword: "Confirm Password",
    CinemaType: "Cinema",
    EventType: "Event",
    // Login ====== BUTTON
    ReSendKey: 'Re-Send Code',
    BackBtn: 'Login',
    BackToEmail: "Back to change Email",
    // Login ====== ERROR MESSAGE
    networkError: "Network Error",
    emailError: "email is not correct",
    codeError: "the code is not correct",
    userError: "forbidden user",
    loginError: "Password or email is not correct",
    //Reports
    showRecords: "Showing Records",
    showAllRecords: "Show All Records",
    // Rules
    rule: "Rules",
    //User Profile
    adminJob: "Admin",
    memberSince: "Member Since",
    profile: "Profile",
    EditReqDone: 'Edited Successfully',

    // User
    activate: "Activate",
    deactivate: "Deactivate",
    activateed: "Active",
    deactivated: "Not Active",
    activationTitle: "Activate Account",
    deactivationTitle: "Deactivate Account",
    activationAlert: "Are you sure you want to Activate account",
    deactivationAlert: 'Are you sure you want to Deactivate account',
    name: "Name",
    image: "Image",
    type: "Type",
    // Reports
    reports: "Reports",
    selectfilter: "Select Filteration",
    datefilter: "Date Filter",
    selectyear: "Select Year",
    selectmonth: "Select Month",
    colsfilter: "Cols Filter",
    searchby: "Search By",
    EditBTN: 'Edit',
    Roles: 'Roles',
    personalInfo: 'Personal Information',
    SubAdminImage: 'Sub Admin Image',
    email: 'Email',
    phone: 'Phone Number',
    status: 'Status',
    RegesteredDate: 'Registered Date',
    RegesteredFrom: 'Registered Since',
    years: 'year',
    month: 'month',
    foryear: 'for year',
    forMonth: 'for month',
    // Clients
    address: "Address",
    Clientinfo: "Client",
    ClientWallet: "Wallet",
    ClientName: "Name",
    usermail: "Email",
    userphone: "Phone",
    status: "Status",
    createdat: "Created At",
    currency: "Ryial",
    balance: "Balance",
    ClientReservation: "Reservations",
    NoReservations: "There is no Reservations",

    FilmCategory: 'Film Category : ',
    ticketPricing: 'Ticket Pricing ',
    AvailableticketPricing:'Available Tickets',
    reservationowner: "Reservation Owner",
    Desc: 'Film Description : ',
    FilmDetails: 'Film Details',
    locationShow: 'Locations Show',
    LE: 'R.S',
    ShowTime: 'Show Times',
    From: 'From',
    To: 'To',
    charge: "Charge",
    reservations: "Reservations",
    TicketType: "Ticket Type",
    paymentmethod: "Payment Method",
    TicketPrice: "Ticket Price",
    Ticketfor: "Ticket for",
    ticket: "Ticket",
    entranceTime: "Entrance Time",
    reservationTime: "Reservation Time",

    filmtype: "Film Type",
    filmdesc: "Film Description",
    filmname: "Film Name",
    showname: "Show Name",
    showdes: "Show Description",

    //Cinema 
    address:"Address",
    locationtitle: "Location",
    hallname: "Hall Name",
    numofchairs: "Number if Chairs",
    movieslist: "Movies showed in Hall",
    Cinemainfo: "Cinema",
    hall:"Hall",
    halls: "Halls",
    films: "Films",
    NoFilms: "There is no Films ",
    NoHalls: "No Halls Exist",
    // Event
    EventsLocation:"Event Location",
    Eventinfo: "About Event",
    Events: "Events",
    NoEvents: "There is no Events",
    //Notification 
    notificationInfo: "Notification",
    description: "description",
    createdAt: "Date",
    Clients: "Clients",
    ShowDetails: 'Show Location Details',
    ShowPlaceName: 'Show Place Name ',
    showPlaceAlt: 'Show Location Image',
    showPlaceDes: 'Show location Description',
    locationOnMap: 'Location On Map',
    offer: 'Offer',
    NoOffer: 'Nop Offer',
    NumberOfPlaces: 'Number Of places',
    AddNewDate: 'Add New Date',
    AddShowTitle: 'Add Show Locations',
    EditShowTitle: 'Edit Show Locations',
    ShowTime: 'Show Timing',
    ticketPricingAfterOffer: 'Ticket Pricing After Offer',
    since: "Since",
    validationTime: 'Should Enter Date and Time',
    usersOf: "Category ",
    NoCinemainCategory: 'No Cinemas In this Category',
    NoEventinCategory:'No Events In this Category',
    seatnumber: "Seat",
    ticketnumber: "Ticket Number",
    CASH: "Cash",
    WALLET: "From Wallet",
    CREDIT: "Credit Card",
    NoFilmsInHall: 'No Shows In This Hall',
    NoShowEvents: 'No Events In This Hall',
    NoShowLocation: 'No Show Locations selected for this film',
    show:"Shows",
    numofshows: "Shows",
    numoffilms: "Films",
    numofhalls: "Halls",
    profit: "Profits",
    numofshares: "Shares",
    NoTickets:'No Tickets',
    TicketTypes:'Ticket Types : ',
    chooseTicketPrice:'Should Select Ticket Prices',
    capcity:"Capcity",
    Show:"Show",
    LatestShow:"Latest Show",
    EventNAme:'Event Name',
    EventDes:'Event Description',
    HallName:'Hall',
    NumOfChair:'Number Of Chairs',
    LocationOnMap:'Location On Map',
    // SendRoles:'Send Selected Roles',
    // SelectAllRoles:'Send All Roles',
    // UnSelectAllRoles:'Cancel All Roles',
    sendRules:'Send Selected Roles',
    selectAllRules:'Send All Roles',
    UnSelectAllRules:'Cancel All Roles',
    //Halls
    chairs:"chairs",
    noChairs:"No Chairs in Hall",
    LatestShow:"Latest Show",
    LastFilm:"Latest Film",
    chair:"chair number",
    Hallinfo:"About Hall",
    allChairs:"Chairs",
    addChairs:"Add Chairs",
    editChairs:"Edit Chair number",
    ticketsPricing:" from ticket Pricing",
    notAssignedChairs:" notAssigned Chairs",
    AllFilms:"All Films",
    AllFilmsHint:"Available Films in System",
    numberOfPlacesError:"you must assign all chairs to ticket pricing type",
    film:"Film",
    chairunit:"chair",
    hour:'HH',
    Min:'MM',
    lastFiveEvent:'The Last Five Events',
    AllEvents:'All Events',
    EventLocation:'Events Locations',
    NumOFShare:'Number Of Shares',
    noShowTimes:'There ara no Show Times',
    cinemaName:'Cinema Name',
    Cinemareservations:'Cinema Reservation',
    Eventreservations:'Event Reservation',
    Reservation:'Reservations',
    hint:"Hint",
    hinttext:"Please distribution All chairs Among Ticket Categories",
    ticketpricingnote:"Please add Ticket Category First",
    yearErr:'Please Select The Year',
    monthErr:'Please Select The Month',
    colsErr:'Please Select The Columns',  
    LatestMember:"Latest Clients",
    attachTicket:" Determine Ticket",
    ShowDate:"Show Date",
    validationError:"Invalid Date",
    ticketerror:"Please add Ticket Category First",
    showplacesEmpty:'Please add Show places ',
    Addticket:"Add Ticket Page",
    Addhall:'Add Hall Page',
    of:"Of",
    Offer:'Offer',
    rate:'Rate',
    TicketPriceAfterDiscount:"Total Price after discount",
    Cashierinfo:'Cashier',
    tickets:'Tickets',
    multiImgErrFlag:'please upload images for the slider',
    addVideo:'Add Video',
    addMultiImage:'Add Multi Image',
    noTickets:'No Tickets',
    ticketsSoldOut:'Tickets Sold Out',
    totlaAmout:'Total Money',
    RemainingAmount:'Remaining Amount',
    unit:"S.R",
    selectAllChairs:"Select all chairs",
    changeTicketType:"Change ticket type",
    selectTicket:'Select Ticket',
    pleaseSelectTicktType:'Please Select ticket type',
    editBtn:'Edit',
    selectAllChairs:"Select all chairs",
    changeTicketType:"Change ticket type",
    selectTicket:'Select Ticket',
    pleaseSelectTicktType:'Please Select ticket type',
    credit:'Credit',
    AdminBalance:'Admin Balance',
    CinemaBalance:'Cinema Balance',
    unit:'S.R',
    yes:'Yes',
    no:'No',
    EvnetBalance:'Event Organizer balance',
    History:'Transaction',
    noHostory:'No Transaction',
    noBalance:'No Balance',
    ticketCount:"Ticket count",
    transferCount:"Transfered",
    nottransferCount:"Un transfered",
    adminBalance:"Admin Balance",
    RemainingAdminBalance:"Remaining",
    orgBalance:"Event Organizer  Balance",
    RemainingOrgBalance:"Remaining",
    totalAmount:"Total amount",
    ticketinfo:"Ticket",
    ticketsinfo:"Tickets",
    admincat:"Admin",
    EventOrgCat:"Event Organizer",
    AllTicketsbalance:"All Tickets",
    RemainingCinemaBalance:"Cinema Balance",
    CinemaOrgCat:"Cinema",
    startDate: "Start Date",
    endDate: "End Date",
    DatesAndTimes: "Dates & Times",
    sat: "Saturday",
    mon: "Monday",
    sun: "Sunday",
    tue: "Tuesday",
    wednesday: "wednesday",
    thursday: "thursday",
    friday: "friday",
    Offer:"Offer",
    addTime: "Add Time",
    pm:"pm",
    am:'am',
    addDateAndTime: "Add Date & Time",
    to: 'to',
    from: 'from',
    selectAttachChairs: 'Select Chairs',
    attachAutomaticChairErr:'Please choose accepted values',
    Count_Number: "Totoal Count: ",
  },

 

  ar: {
    Count_Number: "العدد الأجمالي",
    pm:'مساءا',
    am:'صباحا',
    Offer:'خصم',
    to: 'الى',
    from: 'من',
    attachAutomaticChairErr:'من فضلك أدخال قيم صحيحة',
    selectAttachChairs: 'قم بتحديد الكراسي',
    addDateAndTime: "أضف وقت و تاريخ",
    addTime: "أضافة وقت",
    friday: "الجمعة",
    thursday: "الخميس",
    wednesday: "الاربعاء",
    tue: "الثلاثاء",
    sun: "الاحد",
    mon: "الاثنين",
    sat: "السبت",
    DatesAndTimes: "التواريخ و الأوقات",
    endDate: "نهاية التاريخ",
    startDate: "بداية التاريخ",
    CinemaOrgCat:"السينما",
    RemainingCinemaBalance:"رصيد السينما",
    AllTicketsbalance:"جميع التذاكر",
    EventOrgCat:"منظم الفاعلية",
    admincat:"الادمن",
    ticketinfo:"تذكرة",
    ticketsinfo:"تذاكر",
    totalAmount:"إجمالي المبلغ",
    orgBalance:"رصيد منظم الفاعلية",
    RemainingOrgBalance:"متبقي له",
    adminBalance:"رصيد الادمن",
    RemainingAdminBalance:"متبقي له",
    nottransferCount:"لم يتم تحويل",
    transferCount:"تم تحويل",
    ticketCount:"عدد التذاكر",
    Aboutbalance:"عن الرصيد",
    noBalance:'لا يوجد رصيد',
    noHostory:'لا يوجد عمليات التحويل',
    History:'عمليات التحويل',
    EvnetBalance:'حساب منظم الفاعلية ',
    yes:'نعم',
    no:'لا',
    CinemaBalance:'حساب السينما',
    unit:"ريال",
    AdminBalance:'حساب الادمن',
    credit:'الحاسبة',
    pleaseSelectTicktType:'من فضلك أختر نوع التذكرة',
    selectTicket:'أختر تذكرة',
    changeTicketType:"تغيير نوع التذاكر",
    selectAllChairs:"أختر كل الكراسي",
    editBtn:'تعديل',
    pleaseSelectTicktType:'من فضلك أختر نوع التذكرة',
    selectTicket:'أختر تذكرة',
    changeTicketType:"تغيير نوع التذاكر",
    selectAllChairs:"أختر كل الكراسي",
    unit:'ريال',
    RemainingAmount:'المبلغ المتبقي',
    totlaAmout:'إجمالي المبلغ',
    ticketsSoldOut:'التذاكر المُباعة',
    noTickets:'لا يوجد تذاكر',
    addMultiImage:'إضف صور متحركة',
    addVideo:'أضف فيديو',
    multiImgErrFlag:'من فضلك اضف صور',
    tickets:'التذاكر',
    TicketPriceAfterDiscount:"السعر بعد الخصم",
    Cashierinfo:'كاشير',
    rate:'تقيم',
    Offer:'الخصم',
    of:"من",
    Addhall:'صفحة إضافة مكان عرض',
    Addticket:"صفحة إضافة فئات التذاكر ",
    ticketerror:" من فضلك قم بأدخال فئات التذاكر أولا ",
    showplacesEmpty:'من فضلك اضف أماكن العرض',
    validationError:"الموعد غير صحيح",
    ShowDate:"مواعيد العرض",
    attachTicket:"تحديد  نوع التذكرة",
    colsErr:'من فضلك اختار الاعمدة',
    monthErr:'من فضلك اختار الشهر',
    yearErr:'من فضلك اختار السنة',
    ticketpricingnote:"من فضلك أدخل فئات التذاكر أولا",
    Reservation:'الحجوزات',
    hint:"ملحوظة",
    hinttext:"من فضلك قم بتوزيع جميع الكراسي علي فئات التذاكر",
    Eventreservations:'حجوزات الفاعليات',
    Cinemareservations:'حجوزات السينما',
    eventCreator:"منظم الفاعلية",
    cinemaName:'اسم السينما',
    noshows:" لا يوجد عروض",
    showcreatedat:"تاريخ الأنشاء",
    Filmshow:"عرض لفيلم",
    showDescrip:"وصف العرض",
   
    chairunit:"كرسي",
    // Common
     // Common
     noShowTimes:'لم يتم تحديد اوقات للعرض',
     NumOFShare:'عدد مرات المشاركة',
     EventLocation:'مواقع الفاعليات',
     lastFiveEvent:'اخر خمس فاعليات',
     AllEvents:'كل الفاعليات',
     hour:'ساعة',
     Min:'دقيقة',
    sendRules:'ارسال الصلاحيات المختارة',
    selectAllRules:'اختيار كل الصلاحيات',
    UnSelectAllRules:'الغاء كل الصلاحيات',
    LocationOnMap:'العنوان علي الخريطة',
    NumOfChair:'عدد الكراسي',
    HallName:'القاعة',
    EventDes:'وصف الفاعلية',
    EventNAme:'اسم الفاعلية',
    LatestShow:"أحدث العروض",
    Show:"العرض",
    capcity:"السعة",
    chooseTicketPrice:'يجب اختيار اسعار التذاكر',
    TicketTypes:'انواع التذاكر : ',
    NoTickets:'لا توجد تذاكر',
    NoShowLocation:'لم يتم تحديد اماكن عرض لهذا الفيلم ',
    comingSoon:"قريبا",
    call:"الأتصال",
    mailing:"البريد الالكتروني",
    film:"الفيلم",
    AllFilmsHint:"جميع الأفلام المتاحة بالمنظومة",
    AllFilms:"جميع الأفلام",
    LastFilm:"أحدث الأفلام",
    LatestShow:"أحدث العروض",
    currentLocation:"الموقع",
    FilmImage:"صورة الفيلم",
    show: "العرض",
    table: "جدول",
    card: "كاردات",
    preview: "سلايدر",
    NoShowLocation: 'لم يتم تحديد اماكن عرض لهذا الفيلم ',

    searchRegion:"البحث عن المنطقة ...",
    loading:"جاري التحميل...",
    NoShowEvents:'لا توجد فاعليات في هذه القاعة',
    NoFilmsInHall:'لا توجد عروض في هذه القاعه',
    comingSoon: "قريبا",
    call: "الأتصال",
    mailing: "البريد الالكتروني",
    NoShowEvents: 'لا توجد فاعليات في هذه القاعة',
    NoFilmsInHall: 'لا توجد عروض في هذه القاعه',
    NoCinemainCategory: 'لا يوجد سينيمات في هذه الفئة',
    NoEventinCategory: 'لا يوجد فعليات في هذه الفئة',
    usersOf: "فئة",
    validationTime: 'يجب ادخال الوقت و التاريخ',
    ticketPricingAfterOffer: 'اسعار التذاكر بعد خصم',
    ShowTime: 'اوقات العرض',
    AddShowTitle: "اضافة مكان عرض",
    EditShowTitle: "تعديل مكان عرض",
    AddNewDate: 'اضافة معاد اخر',
    NumberOfPlaces: 'عدد الكراسي',
    NoOffer: 'لا يوجد خصم',
    offer: 'خصم',
    locationOnMap: 'الموقع علي الخريطة',
    showPlaceDes: 'وصف مكان العرض',
    showPlaceAlt: 'صورة لمكان العرض',
    ShowPlaceName: 'اسم مكان العرض',
    ShowDetails: 'تفاصيل مكان العرض',
    To: 'الي',
    From: 'من',
    ShowTime: 'اوقات العرض',
    LE: 'ريال',
    locationShow: 'اماكن العرض',
    FilmDetails: 'تفاصيل الفيلم',
    Desc: 'وصف الفيلم : ',
    ticketPricing: 'اسعار التذاكر ',
    AvailableticketPricing:'التذاكر المتاحة',
    reservationowner: "صاحب الحجز",
    FilmCategory: 'فئة الفيلم :',
    RegesteredFrom: 'موجود منذ',
    RegesteredDate: 'تاريخ التسجيل',
    status: 'الحالة',
    phone: 'رقم الهاتف',
    email: 'البريد الالكتروني',
    SubAdminImage: 'صورة المسؤول',
    Roles: 'الصلاحيات',
    personalInfo: 'المعلومات الشخصية',
    EditBTN: 'تعديل',
    LastActivities: "أحدث العروض ",
    LatestMember:"أحدث المستخدمين",

    username: "الأسم",
    RegesteredFrom: 'موجود منذ',
    RegesteredDate: 'تاريخ التسجيل',
    status: 'الحالة',
    phone: 'رقم الهاتف',
    email: 'البريد الالكتروني',
    SubAdminImage: 'صورة المسؤول',
    Roles: 'الصلاحيات',
    personalInfo: 'المعلومات الشخصية',
    EditBTN: 'تعديل',
    username: "الأسم",
    Retry: 'اعادة المحاولة',
    NoExist: 'لا يوجد',
    loadMore: "تحميل المزيد",
    readMore: "قراءة المزيد",
    confirm: "تأكيد",
    CancelBTN: "ألغاء",
    createBTN: "انشاء",
    Btn_Filter: "البحث",
    SendKey: "ارسال",
    addBTN: 'اضافة',
    edittip: "تعديل",
    deletetip: "حذف",
    details: "التفاصيل",
    viewtip: "التفاصيل",
    EditBTN: "تعديل",
    // logout
    SingOut: "خروج",
    confirmation: "هل تريد تسجيل الخروج",
    logout: "تسجيل الخروج",
    // Login
    loginKey: " تسجيل الدخول",
    UserType: "نوع المستخدم",
    AdminType: "مسؤول",
    SubAdminType: "مسؤول فرعي",
    forgetPasswordKey: "نسيت كلمة المرور",
    EnterPassword: "ادخل كلمة المرور",
    EnterMail: "ادخل البريد الاليكتروني",
    confirmpassword: "تاكيد كلمة المرور",
    CinemaType: "سينما",
    EventType: "فاعلية",
    // Login ====== BUTTON
    ReSendKey: 'اعادة ارسال الكود',
    BackBtn: ' تسجيل الدخول',
    BackToEmail: "العودة لتغيير الايميل",
    // Login ====== ERROR MESSAGE
    networkError: "خطأ فى الاتصال بالانترنت",
    emailError: "البريد الالكترونى  غير صحيح",
    codeError: "الرمز التاكيدي غير صحيح",
    userError: "هذا الحساب غير موجود",
    loginError: "البريد الالكترونى او كلمة المرور غير صحيحة",
    //Reports
    showRecords: "عرض ",
    showAllRecords: "عرض الكل",
    // Rules
    rule: "صلاحيات",
    //User Profile
    adminJob: "أدمن",
    memberSince: "عضو منذ",
    profile: "الصفحة الشخصية",
    EditReqDone: 'تم التعديل بنجاح',
    // User
    activate: "تنشيط",
    deactivate: "تعطيل",
    activateed: "نشط",
    deactivated: "غير نشط",
    activationTitle: "تنشيط حساب",
    deactivationTitle: "تعطيل حساب",
    activationAlert: "هل أنت متأكد من تنشيط حساب",
    deactivationAlert: 'هل أنت متأكد من تعطيل حساب',
    name: "الاسم",
    image: "الصورة",
    type: "النوع",
    // Reports
    reports: "التقارير",
    selectfilter: "اختار التصفية",
    datefilter: "تصفية التاريخ",
    selectyear: "اختار السنة",
    selectmonth: "اختار الشهر",
    colsfilter: "تصفية الاعمدة",
    searchby: "البحث بواسطة",
    years: 'السنة',
    month: 'الشهر',
    foryear: 'لسنة',
    forMonth: 'لشهر',

    // Clients
    address: "العنوان",
    Clientinfo: "العميل",
    ClientWallet: "المحفظة",
    ClientName: "الأسم",
    usermail: "البريد الألكتروني",
    userphone: "رقم الهاتف",
    status: "الحالة",
    createdat: "تاريخ الأشتراك",
    currency: "ريال",
    balance: "الرصيد",
    ClientReservation: "الحجزات",
    NoReservations: "لا يوجد حجزات",

    charge: "الرصيد",
    reservations: "الحجوزات",
    TicketType: "نوع التذكرة",
    paymentmethod: "طريقة الدفع",
    TicketPrice: "سعر التذكرة",
    Ticketfor: "التذكرة لدخول",
    locationtitle: "موقعك",
    ticket: "التذكرة",
    entranceTime: "موعد الدخول",
    reservationTime: "موعد الحجز",


    filmtype: "نوع الفيلم",
    filmdesc: "وصف الفيلم",
    filmname: "اسم الفيلم",
    showname: "اسم العرض",
    showdes: "وصف العرض",
    //Cinema
    address:"العنوان",
    locationtitle: "الموقع",
    NoFilms: "لا يوجد أفلام ",


    hallname: "اسم القاعة",
    numofchairs: "عدد الكراسي",
    movieslist: "الافلام المعروضة في القاعة",
    Cinemainfo: "السينما",
    hall:"القاعة",
    halls: "القاعات",
    films: "أفلام",
    NoHalls: "لا يوجد قاعات",
    // Event
    EventsLocation:"أماكن الفعليات",
    Eventinfo: "عن الفاعلية ",
    Hallinfo: "عن القاعة ",
    Events: "الفاعليات",
    NoEvents: "لا يوجد فعليات",
    //Notification 
    notificationInfo: "الاشعار",
    description: "النص",
    createdAt: "التاريخ",
    Clients: "العملاء",
    since: "منذ",

    seatnumber: "مقعد",
    ticketnumber: "رقم التذكرة",
    CASH: "نقدا",
    WALLET: ' من المحفظة',
    CREDIT: " بالبطاقة الائتمانية",
    show:"العرض",
    numofshows: " العروض",
    numoffilms: " الافلام",
    numofhalls: " القاعات",
    profit: "الارباح",
    numofshares: " المشاركات",
     //Halls
     chairs:"الكراسى",
     noChairs:"لا يوجد كراسي بالقاعة ",
     chair:"كرسى رقم",
     allChairs:"الكراسى",
     addChairs:"إضافة الكراسى",
     editChairs:"تعديل الكرسى رقم ",
     ticketsPricing:" من الفئة ",
     notAssignedChairs:"الكراسى الغير محددة الفئة",
     numberOfPlacesError:"يجب تحديد فئة جميع الكراسى"

  }
});
export default strings;